import { URI, VERSION, MODELNAME, packageUrl } from '@/model/config';

const subModel = 'project';

const makeUrl = (method:string) => {
    return packageUrl(method, subModel);
};

const METHOD = {
    addProject: 'addProject',
    getProjects: 'getProjects',
    deleteProject: 'deleteProject',
    updateProject: 'updateProject'
};
const regex = {
    maxClientsCount: /^[1-9]\d{0,5}$/
};

const PROJECTMANAGE = {
    baseurl: URI,
    model: MODELNAME,
    version: VERSION,
    method: METHOD,
    url: {
        addProject: makeUrl(METHOD.addProject),
        getProjects: makeUrl(METHOD.getProjects),
        deleteProject: makeUrl(METHOD.deleteProject),
        updateProject: makeUrl(METHOD.updateProject)
    }
};

export default PROJECTMANAGE;
